import { Link } from "react-router-dom";
import aboutImage1 from "../assets/images/aboutImage1.jpg";
import aboutImage2 from "../assets/images/aboutImage2.jpg";
import aboutImage3 from "../assets/images/aboutImage3.jpg";
import { appName, gradesRange, whatsappUrl } from "../common";

const About = () => {
  return (
    <div className="page">
      <section className="section split">
        <div className="text">
          <h1>Who we are</h1>
          <p className="section-text">
            {appName} is an education initiative focused on STEM, robotics, coding,
            and AI foundations for school students. We nurture curiosity,
            creativity, and problem-solving through structured, hands-on programs —
            not slides alone.
          </p>
          <p className="section-text">
            We work with learners from <strong>{gradesRange}</strong>, meeting them
            where they are and scaling complexity as confidence grows.
          </p>
        </div>

        <div className="image">
          <img src={aboutImage1} alt={`About ${appName}`} />
        </div>
      </section>

      <section className="section section-block about-nep">
        <h2>Aligned with NEP 2020</h2>
        <p className="section-text">
          India’s National Education Policy 2020 encourages experiential learning,
          multidisciplinary thinking, and digital literacy from school onward. Our
          robotics and coding pathways are built to support that spirit: students
          design, build, debug, and present — skills that transfer beyond any single
          subject.
        </p>
      </section>

      <section className="section split reverse">
        <div className="text">
          <h2>Robotics &amp; IoT in plain terms</h2>
          <p className="section-text">
            Robotics brings together electronics, mechanics, and programming so
            machines can sense, decide, and act. The Internet of Things (IoT)
            connects devices and data — the same ideas power smart homes, farms, and
            industry.
          </p>
          <p className="section-text">
            In our sessions, students see how code on a laptop becomes motion on the
            floor: sensors read the world, logic handles decisions, and outputs move
            wheels, lights, or arms.
          </p>
        </div>

        <div className="image">
          <img src={aboutImage2} alt="Robotics and IoT learning" />
        </div>
      </section>

      <section className="section split">
        <div className="text">
          <h2>How we help students</h2>
          <p className="section-text">
            Programs are project-based: concepts arrive when they are needed for the
            next build. We emphasise teamwork, iteration, and presentation — so
            learners can explain what they made and why it matters.
          </p>
          <p className="section-text">
            Parents get clarity on milestones; schools get a partner for labs,
            clubs, and annual STEM events. Ready to explore a batch or a pilot?
          </p>
          <div className="about-actions">
            <a className="btn btn-primary" href={whatsappUrl} target="_blank" rel="noreferrer">
              Message on WhatsApp
            </a>
            <Link className="btn btn-ghost" to="/contact">
              Email &amp; location
            </Link>
          </div>
        </div>

        <div className="image">
          <img src={aboutImage3} alt="Hands-on robotics education" />
        </div>
      </section>
    </div>
  );
};

export default About;
